import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { IconButton } from '@mui/material';
import { useRouter } from 'src/routes/hooks';
import {deleteTelecarePackage} from '../../services/telehealth-packages.service';
import Iconify from '../iconify';

export default function DeleteTelecarePackageDialog({ packageId, clinicId }) {
  const [open, setOpen] = React.useState(false);
  const router = useRouter();

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const onClickDelete = async () => {
    try {
      await deleteTelecarePackage(packageId, clinicId);
    } catch (error) {
      console.error('Failed to delete telecare package:', error);
    }
    handleClose();
    router.reload();
  };

  return (
    <>
      <IconButton onClick={handleClickOpen}>
        <Iconify icon="tabler:trash" />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-telecare-dialog-title"
        aria-describedby="delete-telecare-dialog-description"
      >
        <DialogTitle id="delete-telecare-dialog-title">
          Delete Telecare Package
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="delete-telecare-dialog-description">
            Are you sure you want to delete this telecare package?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={onClickDelete} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
